import React from 'react';
import './StarRating.css'; // We will create this CSS file next

const StarRating = ({ rating }) => {
  const totalStars = 5;

  return (
    <div className="star-rating">
      {[...Array(totalStars)].map((_, index) => {
        const starValue = index + 1;
        // Calculate the fill percentage for this star
        let fillPercentage = 0;
        if (starValue <= rating) {
          fillPercentage = 100; // Full star
        } else if (starValue - 1 < rating && starValue > rating) {
          fillPercentage = (rating - (starValue - 1)) * 100; // Partial star
        }

        return (
          <div key={starValue} className="star-container">
            <span className="star-outline">★</span>
            <span 
              className="star-fill"
              style={{ width: `${fillPercentage}%` }}
            >
              ★
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default StarRating; 